import { render, staticRenderFns } from "./SvgDoughnut.vue?vue&type=template&id=0136205d&"
import script from "./SvgDoughnut.vue?vue&type=script&lang=js&"
export * from "./SvgDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports